import React, { useState, useEffect } from "react";
import { NavLink, To } from "react-router-dom";
import UsuarioPesquisaPopup from "../../Pages/Cadastros/Usuario/UsuarioPesquisaPopup";
import '../../Styles/Menu.css';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useConfirm } from "material-ui-confirm";
import ConeConfiguracaoPopup from "../../Pages/Paineis/ConeDeRisco/ConeConfiguracaoPopup";
import ConeLogisticoOperacoesPopup from "../../Pages/Paineis/ConeLogistico/ConeLogisticoOperacoesPopup";
import ConeLogisticoConfiguracaoPopup from "../../Pages/Paineis/ConeLogistico/ConeLogisticoConfiguracaoPopup";
import ConeLogisticoFiltroPopup from "../../Pages/Paineis/ConeLogistico/ConeLogisticoFiltroPopup";
import ConeOperacoesPopup from "../../Pages/Paineis/ConeDeRisco/ConeOperacoesPopup";
import { Menu, MenuProps } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRoad } from "@fortawesome/free-solid-svg-icons";
import {
  AppstoreOutlined,
  DesktopOutlined,
  PieChartOutlined,
  BarChartOutlined,
  FileExclamationOutlined
} from '@ant-design/icons';
import EmpresaPesquisaPopup from "../../Pages/Cadastros/Empresa/EmpresaPesquisaPopup";
import OperacaoPesquisaPopup from "../../Pages/Cadastros/Operacao/OperacaoPesquisaPopup";
import VeiculoPesquisaPopup from "../../Pages/Cadastros/Veiculo/VeiculoPesquisaPopup";
import MotoristaPesquisaPopup from "../../Pages/Cadastros/Motoristas/MotoristaPesquisaPopup";
import EventoLogisticoOperacoesPopup from "../../Pages/Paineis/EventoLogistico/EventoLogisticoOperacoesPopup";
import RelatorioReportTrackingPopup from "../../Pages/Relatorios/ReportTracking/RelatorioReportTrackingPopup";
import ControleDocaOperacoesPopup from "../../Pages/Paineis/ControleDoca/ControleDocaOperacoesPopup";
import ControleDocaConfiguracaoPopup from "../../Pages/Paineis/ControleDoca/ControleDocaConfiguracaoPopup";
import RelatorioControleDocaPopup from "../../Pages/Relatorios/ControleDoca/RelatorioControleDocaPopup";
import RotogramaViagemRelatorioPopup from "../../Pages/Relatorios/RotogramaViagem/RotogramaViagemRelatorioPopup";
import EnvioRotogramaViagemPopup from "../../Pages/Relatorios/RotogramaViagem/EnvioRotogramaViagemPopup";


const MenuProComponent = (props: any) => {
  const [menuItems, setMenuItems] = useState<any[]>([]);
  const [toggleMenuCollapse, setToggleMenuCollapse] = useState<boolean>(false);

  const [usuarioOpen, setUsuarioOpen] = useState(false);
  const [empresaOpen, setEmpresaOpen] = useState(false);
  const [operacaoOpen, setOperacaoOpen] = useState(false);

  const [coneConfiguracaoOpen, setConeConfiguracaoOpen] = useState(false);
  const [coneOperacoesOpen, setConeOperacoesOpen] = useState(false);

  const [coneLogisticoConfiguracaoOpen, setConeLogisticoConfiguracaoOpen] = useState(false);
  const [coneLogisticoOperacoesOpen, setConeLogisticoOperacoesOpen] = useState(false);
  const [coneLogisticoFiltroOpen, setConeLogisticoFiltroOpen] = useState(false);

  const [controleDocaOperacoesOpen, setControleDocaOperacoesOpen] = useState(false);
  const [controleDocaConfiguracaoOpen, setControleDocaConfiguracaoOpen] = useState(false);

  const [painelEventosLogisticosOperacoesOpen, setPainelEventosLogisticosOperacoesOpen] = useState(false);
  const [relatorioReportTrackingOpen, setRelatorioReportTrackingOpen] = useState(false);
  const [relatorioControleDocasOpen, setRelatorioControleDocasOpen] = useState(false);
  const [veiculoOpen, setVeiculoOpen] = useState(false);
  const [motoristaOpen, setMotoristaOpen] = useState(false);
  const [rotogramaViagemRelatorioOpen, setRotogramaViagemRelatorioOpen] = useState(false);
  const [envioRotogramaOpen, setEnvioRotogramaOpen] = useState(false);

  const [usuarioPaineis, setUsuarioPaineis] = useState<any[]>([]);
	const navigate = useNavigate();
  const confirm = useConfirm();
  type MenuItem = Required<MenuProps>['items'][number];

  function menuItem(
    label: React.ReactNode,
    key: React.Key,
    onClick?: {},
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: 'group'): MenuItem
  {
    return { key, icon, onClick, children, label, type, } as MenuItem;
  }

  useEffect(() => {
    (async () => {
      let response = await axios.get('usuarioPaineis');
      setUsuarioPaineis(response.data);
    })();
  }, []);

  useEffect(() => {
    loadMenu();
  }, [usuarioPaineis, props.usuario]);

  useEffect(() => {
    setToggleMenuCollapse(props.toggleMenuCollapse);
  }, [props.toggleMenuCollapse]);

  function loadMenu()
  {
    const itens: any[] = [];
    itens.push(menuItem('Viagens', 'viagens', () => {}, <NavLink to="/"><FontAwesomeIcon icon={faRoad} /></NavLink> ));
    if (props.usuario.perfil_id == 1) {
      itens.push(menuItem('Cadastros', 'cadastros', () => {}, <DesktopOutlined />, [
          menuItem('Motoristas', 'motoristas', () => setMotoristaOpen(true)),
          menuItem('Empresas', 'empresas', () => setEmpresaOpen(true)),
          menuItem('Veiculos', 'veiculos', () => setVeiculoOpen(true)),
          menuItem('Operações', 'operacoes', () => setOperacaoOpen(true)),
          menuItem('Usuários', 'usuarios', () => setUsuarioOpen(true)),
        ]));
    }

    if (usuarioPaineis != null && usuarioPaineis.length > 0)
    {
      let powerBI: any[] = [];
      usuarioPaineis.forEach((e: any) => {
        powerBI.push(
          menuItem(e.nome_painel, `powerbi${e.id}`, () => navigate('/painel', { 'state': {'url': e.url_painel} }))
        );
      });

      itens.push(menuItem('Power BI', 'powerbi', () => {}, <PieChartOutlined label="Power BI" />, powerBI));
    }

    let paineis:any[] = [];
    if (props.usuario.permissao_cone==1 || props.usuario.ver_painel_performance==1)
    {

      if (props.usuario.permissao_cone==1)
      {
        paineis.push(
          menuItem('Cone de Risco', 'conederisco_main', () => {}, null,
            [
              menuItem('Painel', 'conederisco', () => navigate('/conederisco')),
              menuItem('Configurações', 'cone_configuracoes', () => setConeConfiguracaoOpen(true)),
              menuItem('Operações', 'cone_operacoes', () => setConeOperacoesOpen(true))
            ]
          )
        );
      }

      if (props.usuario.permissao_cone==1)
      {
        paineis.push(
          menuItem('Cone Logistico', 'conelogistico_main', () => {}, null,
            [
              menuItem('Painel', 'conelogistico', () => navigate('/conelogistico')),
              menuItem('Configurações', 'cone_logistico_configuracoes', () => setConeLogisticoConfiguracaoOpen(true)),
              menuItem('Operações', 'cone_logistico_operacoes', () => setConeLogisticoOperacoesOpen(true)),
              menuItem('Filtro', 'cone_logistico_filtro', () => setConeLogisticoFiltroOpen(true))
            ]
          )
        );
      }
    }

    if (props.usuario.ver_painel_performance==1)
    {
      paineis.push(
        menuItem('Eventos Logísticos', 'painel_evento_logistico_main', () => {}, null,
          [
            menuItem('Painel', 'painelLogistico', () => navigate('/painelLogistico')),
            menuItem('Operações', 'painel_evento_logistico_operacoes', () => setPainelEventosLogisticosOperacoesOpen(true))
          ]
        )
      );

    }
    
    if (props.usuario.permissao_controle_doca==1)
    {
      paineis.push(
        menuItem('Controle de Doca', 'controle_doca_main', () => {}, null,
          [
            menuItem('Painel', 'controledoca', () => navigate('/controledocas')),
            menuItem('Configurações', 'controle_doca_configuracoes', () => setControleDocaConfiguracaoOpen(true)),
            menuItem('Operações', 'controle_doca_operacoes', () => setControleDocaOperacoesOpen(true))

          ]
        )
      );
    }

    itens.push(menuItem('Paineis', 'paineis', () => {}, <AppstoreOutlined />, paineis));

    
    let menuItens = [];
    if(props.usuario.permissao_controle_doca==1){
      menuItens.push(menuItem('Controle de Docas', 'relatorioControleDeDocas', () => setRelatorioControleDocasOpen(true)));
    }
    
    if(props.usuario.ver_painel_performance==1){
      menuItens.push(menuItem('Report Tracking', 'relatorioReportTracking', () => setRelatorioReportTrackingOpen(true)));
    }

    menuItens.push(menuItem('Rotograma', 'rotogramaViagem',  () => {}, null,
      [
        menuItem('Relatório', 'rotogramaRelatorio', () => setRotogramaViagemRelatorioOpen(true)),
        props.usuario.enviar_rotograma==1 ? menuItem('Envio Rotograma', 'rotogramaEnvio', () => setEnvioRotogramaOpen(true)) : null,
      ]
    ));

    itens.push(
      menuItem('Relatórios', 'relatorios_main', () => {}, <BarChartOutlined label="Relatórios" />,
        menuItens
      )
    );

    setMenuItems(itens);
  }

  return (
    <div
      className="area-menu-pro"
      style={{width: (toggleMenuCollapse ? '85px' : '256px')}}>
      <Menu
        id="main-menu"
        className="main-menu-pro"
        defaultSelectedKeys={['viagens']}
        onMouseLeave={props.closeMenu}
        mode="inline"
        theme="dark"
        inlineCollapsed={toggleMenuCollapse}
        items={menuItems}
       />

      {usuarioOpen ? <UsuarioPesquisaPopup isOpen={usuarioOpen} onClose={() => setUsuarioOpen(false)} /> : ''}
      {operacaoOpen ? <OperacaoPesquisaPopup isOpen={operacaoOpen} onClose={ () => setOperacaoOpen(false)} /> : ''}
      {coneConfiguracaoOpen ? <ConeConfiguracaoPopup isOpen={coneConfiguracaoOpen} onClose={() => setConeConfiguracaoOpen(false)} /> : ''}
      {coneOperacoesOpen ? <ConeOperacoesPopup isOpen={coneOperacoesOpen} onClose={() => setConeOperacoesOpen(false)} /> : ''}

      {coneLogisticoConfiguracaoOpen ? <ConeLogisticoConfiguracaoPopup isOpen={coneLogisticoConfiguracaoOpen} onClose={() => setConeLogisticoConfiguracaoOpen(false)} /> : ''}
      {coneLogisticoOperacoesOpen ? <ConeLogisticoOperacoesPopup isOpen={coneLogisticoOperacoesOpen} onClose={() => setConeLogisticoOperacoesOpen(false)} /> : ''}
      {coneLogisticoFiltroOpen ? <ConeLogisticoFiltroPopup isOpen={coneLogisticoFiltroOpen} onClose={() => setConeLogisticoFiltroOpen(false)} /> : ''}

      {painelEventosLogisticosOperacoesOpen ? <EventoLogisticoOperacoesPopup isOpen={painelEventosLogisticosOperacoesOpen} onClose={() => setPainelEventosLogisticosOperacoesOpen(false)} /> : ''}
      {empresaOpen ? <EmpresaPesquisaPopup isOpen={empresaOpen} onClose={() => setEmpresaOpen(false)} /> : ''}
      {veiculoOpen ? <VeiculoPesquisaPopup isOpen={veiculoOpen} onClose={() => setVeiculoOpen(false)} /> : ''}
      {motoristaOpen ? <MotoristaPesquisaPopup isOpen={motoristaOpen} onClose={() => setMotoristaOpen(false)} /> : ''}
      {relatorioReportTrackingOpen ? <RelatorioReportTrackingPopup isOpen={relatorioReportTrackingOpen} onClose={() => setRelatorioReportTrackingOpen(false)} /> : ''}
      {relatorioControleDocasOpen ? <RelatorioControleDocaPopup isOpen={relatorioControleDocasOpen} onClose={() => setRelatorioControleDocasOpen(false)} /> : ''}
      
      {controleDocaOperacoesOpen ? <ControleDocaOperacoesPopup isOpen={controleDocaOperacoesOpen} onClose={() => setControleDocaOperacoesOpen(false)} /> : ''}
      {controleDocaConfiguracaoOpen ? <ControleDocaConfiguracaoPopup isOpen={controleDocaConfiguracaoOpen} onClose={() => setControleDocaConfiguracaoOpen(false)} /> : ''}
      {rotogramaViagemRelatorioOpen ? <RotogramaViagemRelatorioPopup isOpen={rotogramaViagemRelatorioOpen} onClose={() => setRotogramaViagemRelatorioOpen(false)} /> : ''}
      {envioRotogramaOpen ? <EnvioRotogramaViagemPopup isOpen={envioRotogramaOpen} onClose={() => setEnvioRotogramaOpen(false)} /> : ''}
    </div>
  )
}

export default MenuProComponent;